// theme/scripts/pages/customize.js

import React, { useContext, useState, useEffect, useLayoutEffect } from 'react';
import { CustomizeContext } from '../contexts/customize';
import MtmSize from '../components/size';
import ConfirmButton from '../common/button';
import MtmCollar from '../components/collar';
import MtmBack from '../components/back';
import MtmCuffs from '../components/cuffs';
import MtmPlackets from '../components/plackets';
import MtmPockets from '../components/pockets';
import MtmButton from '../components/button';
import MtmLabel from '../components/label';
import MtmEmbroidery from '../components/embroidery';
import MtmConfirmBtn from '../components/confirmBtn';

//FIXME
// eslint-disable-next-line no-unused-vars
const flattenObject = (ob) => {
  var toReturn = [];

  for (var i in ob) {
    // eslint-disable-next-line no-prototype-builtins
    if (!ob.hasOwnProperty(i)) continue;

    if (typeof ob[i] == 'object' && ob[i] !== null) {
      var flatObject = flattenObject(ob[i]);
      for (var x in flatObject) {
        // eslint-disable-next-line no-prototype-builtins
        if (!flatObject.hasOwnProperty(x)) continue;

        toReturn.push(flatObject[x]);
      }
    } else {
      toReturn.push(ob[i]);
    }
  }
  return toReturn;
};

const Customize = ({ onClickConfirm }) => {
  const [pocketData, setPocketData] = useState(false);
  const [placketData, setPlacketData] = useState(false);
  
  const { customizes } = useContext(CustomizeContext);
  const reorderData = sessionStorage.getItem('reorder_properties');

  useEffect(() => {
    console.log('🎯 customizes updated:', customizes);
  }, [customizes]);

  useEffect(() => {
    if (reorderData) {
      console.log('📦 reorderData', JSON.parse(reorderData));
    }
  }, [reorderData]);

  useEffect(() => {
    const reorderRaw = sessionStorage.getItem('reorder_properties');
    if (!reorderRaw) return;

    const sections = ['collar', 'back', 'cuffs', 'plackets', 'pocket', 'button', 'size', 'monograms', 'label'];

    sections.forEach((sec) => {
      const el = document.getElementById(`mtm-${sec}`);
      if (el) {
        el.classList.add('active');
      }
    });

    document.getElementById('mtm-confirm')?.classList.add('active');
  }, []);

  return (
    <>
      <MtmCollar />
      <MtmBack />
      <MtmCuffs />
      <MtmPlackets setPlacketData={setPlacketData} />
      <MtmPockets setPocketData={setPocketData} />
      <MtmButton />
      <MtmSize />
      <MtmEmbroidery pocketData={pocketData} placketData={placketData} />
      <MtmLabel />
      <MtmConfirmBtn onClickConfirm={onClickConfirm} />
    </>
  );
};

export default Customize;
